<template>
    <div class="dfAgreement">
        <div class="detail">
            <div class="name">
                Q：花呗分期是什么？
            </div>
            <div class="txt">
                为了维护您的利益，请您认真阅读本协议以下各条款，充分了解您的权利及义务。您阅读并同意本协议后，即表示您已对所有条款的含义及相应的法律后果全部通晓并充分理解，且自愿作出下述授权、承诺和声明。其中，授权包含《征信业管理条例》中征信业务，您应对于《征信业管理条例》及相关法律法规有一定的了解，如您不能清楚地知晓或理解国家相关法律法规规定的内容，您应咨询相关法律专业人士后再决定是否接受本协议。
            </div>
            <div class="name">
                Q：花呗分期如何使用？
            </div>
            <div class="txt">
                A：请参考以下步骤：<br/>
                1、在订单确认页或收银台页面选择花呗分期支付。<br/>
                2、选择好对应的分期期数后提交订单。<br/>
                3、自动跳转至支付宝，进入花呗分期收银台。<br/>
                4、输入支付密码付款成功。
            </div>
            <div class="txt">
                Q：花呗分期退还手续费的规则是什么？
            </div>
            <div class="txt">
                A：已出账且已经支付的手续费不予退还，未支付的手续费，如果已经出了账单则不予退还，未出账单的，根据退款金额按比例进行相应减免。
            </div>
            <div class="name">
                Q：若进行提前还车，费用如何退还至花呗账户？
            </div>
            <div class="txt">
                A：若提前还车，订单剩余退款自动退回支付宝的花呗账户中，已支付且已出账的手续费不予退还，未支付且未出账的手续费将自动退回至支付宝的花呗账户中。
            </div>
            <div class="name">
                Q：使用花呗分期付款后，订单取消怎么退款？
            </div>
            <div class="txt">
                A：退款的费用直接返还至支付宝的花呗账户中，部分涉及到违约金和手续费的相关费用不予退还。
            </div>
            <div class="name">
                Q：修改订单的差额费用在花呗分期中如何计算？
            </div>
            <div class="txt">
                A：修改订单后，如订单金额高于修改前的订单，则需另外支付费用。如订单金额低于修改前的订单，已出账或已支付的手续费不予退还，剩余的订单费用退还至支付宝的花呗账户中。
            </div>
            <div class="name">
                Q：花呗分期租车，分期期数可以取消或修改吗？
            </div>
            <div class="txt">
                A：花呗分期一旦申请后均无法取消，期数也不能修改。若是取消订单并且退款成功后，资金会退回支付宝的花呗账户则相当于取消分期。
            </div>
            <div class="name">
                Q： 花呗分期退款时的资金流是如何变动的？
            </div>
            <div class="txt">
                A： 退款时，资金由商户收款账户退至花呗分期账户，花呗分期实时归还用户该笔交易的剩余未还费用，如剩余未还费用还清后仍有多余金额，则实时退回到用户支付宝余额；在还该笔交易剩余未还费用时，优先归还用户已经出账的欠款，再倒序归还未出账的欠款。<br />
                举例：交易金额1200元，分6期，每期账单200元，商家承担手续费，用户手续费0元，用户已经还款第一期账单200元，第二期账单已出账；场景1： 用户退款1200元，则优先将第二期账单200元结清，再将最后四期账单800元结清，之后退款200元进用户余额，用户额度恢复1000； 场景2： 用户退款600元，则优先将第二期账单200元结清，再将最后两期账单400元结清，用户额度恢复600。
            </div>
            <div class="name">
                Q：花呗分期交易时的资金流是如何变动的？
            </div>
            <div class="txt">
                A：用户每期还款时，资金（本金+手续费）由用户的账户结算至花呗账户。
            </div>
            <div class="name">
                Q：报错“花呗分期暂不可用，你可以使用其他付款方式继续支付或稍后重试” 怎么办？
            </div>
            <div class="txt">
                A：导致该报错的原因可能是：用户没有花呗额度；用户花呗额度不足；该笔交易被判定为高风险交易。用户此时可以选择其它付款方式唤起支付宝收银台继续支付。
            </div>
            <div class="name">
                Q：花呗分期支付失败还能使用其它付款方式吗？
            </div>
            <div class="txt">
                A：可以。如用户不能使用花呗分期，会直接进入错误提示页面，在该页面上可以选择其它付款方式或者继续支付，点击之后可以使用余额、余额宝、支付宝绑定银行卡进行支付。
            </div>
            <div class="name">
                Q：同一个用户（即同一个身份证）可以有多个支付宝账户使用花呗分期付款吗？
            </div>
            <div class="txt">
                A：不可以，只有一个账户可以使用花呗分期服务。
            </div>
            <div class="name">
                Q：用户如何查看花呗分期交易和账单？
            </div>
            <div class="txt">
                A：打开手机支付宝【我的 > 花呗 > 我的账单】查看；如果要查看某一笔花呗分期详情，在【已出账单】或【未出账单】中查到这笔花呗分期订单，点击查看分期详情。
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "huabeiAgreement",
        data() {
            return {

            };
        },
        props: [],
        methods: {
        }
    };
</script>
<style lang="scss" scoped type="text/scss">
    .dfAgreement {
        width:100%;
        display: flex;
        flex-direction: column;
        font-size: 24px;
        background-color: #fff;
        img {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 40px;
            height: 40px;
            background-size: 100%;
        }
        .detail {
            padding: 20px 30px;
            // padding-top:70px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            color: gray;
            overflow: scroll;
            .name {
                margin-top: 20px;
                margin-bottom: 5px;
                font-weight: bold;
            }
            .txt {
                margin-bottom: 10px;
                line-height: 35px;
                text-align: justify;
            }
        }
    }
</style>
